import { type ReviewsViewContext } from "@src/appV2/redesign/ShiftDiscovery/useWorkplaceModalsDataContext";
import { IconWithCountButton } from "@src/appV2/redesign/system/ui-components";
import { useDeleteCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/useDeleteCommentReaction";
import { usePostCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/usePostCommentReaction";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { type CommentReactionSource, Reaction } from "../types";

interface WorkplaceReviewCommentLikesButtonProps {
  isLiked: boolean;
  count: number;
  onLikeChanged: (comment: WorkplaceCommentType) => void;
  workplaceId: string;
  commentId: string;
  source: CommentReactionSource;
  viewContext: ReviewsViewContext;
}

export function WorkplaceReviewCommentLikesButton(props: WorkplaceReviewCommentLikesButtonProps) {
  const { isLiked, count, onLikeChanged, workplaceId, commentId, source, viewContext } = props;

  const { mutate: postCommentReaction } = usePostCommentReaction(
    { workplaceId, commentId, source, viewContext },
    {
      onSuccess: (data) => {
        onLikeChanged(data.data);
      },
    }
  );

  const { mutate: deleteCommentReaction } = useDeleteCommentReaction(
    { workplaceId, commentId, source, viewContext },
    {
      onSuccess: (data) => {
        onLikeChanged(data.data);
      },
    }
  );

  return (
    <IconWithCountButton
      aria-label="Like reaction"
      isActive={isLiked}
      count={count}
      baseIconType="like-outlined"
      activeIconType="like-filled"
      onClick={(event) => {
        event.stopPropagation();

        if (isLiked) {
          deleteCommentReaction({ reactionType: Reaction.LIKE });
        } else {
          postCommentReaction({ reaction: Reaction.LIKE });
        }
      }}
    />
  );
}
